import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Phone, MapPin } from 'lucide-react';
export function AdultHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-538">
      <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-539">
        <Sparkles className="w-4 h-4" data-id="element-540" />
        Adult Classes · All Fitness Levels
      </div>

      <div className="mb-8 inline-flex flex-nowrap items-center gap-3 text-sm md:text-base font-bold text-ink bg-white/90 backdrop-blur-sm py-2 px-4 rounded-full shadow-sm border border-subtle-gray w-fit max-w-full whitespace-nowrap" data-id="element-541">
        <span className="text-gold tracking-wider shrink-0" data-id="element-542">★★★★★</span>
        <span className="text-subtle-gray shrink-0" data-id="element-543">|</span>
        <span className="shrink-0" data-id="element-544">5.0 Rating From 201 Reviews</span>
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1]" data-id="element-545">
        Adult Taekwondo & Martial Arts Classes in Farmington Hills
      </h1>

      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-546">
        Storm Taekwondo offers beginner-friendly adult classes for fitness,
        confidence, discipline, stress relief, and real Taekwondo skill
        development.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-547">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-548">
          Start With a Trial Class
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary flex items-center justify-center gap-2" data-id="element-549">
          <Phone className="w-5 h-5" data-id="element-550" />
          Call 517-220-0621
        </a>
      </div>

      <div className="flex items-start gap-3 text-off-white/80 text-sm" data-id="element-551">
        <MapPin className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-552" />
        <p data-id="element-553">
          24786 Crestview, Farmington Hills, MI 48335 — minutes from Novi,
          Commerce, Walled Lake, Wixom, Livonia, Northville and Waterford.
        </p>
      </div>
    </div>;
}